import './PageModal.scss'

import { Modal } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { Form } from '@websrc/App/Components/Form/Form'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapModal } from '@websrc/DataMappers/mapModal'
import React, { FC, useCallback, useContext, useLayoutEffect, useState } from 'react'
import { match } from 'ts-pattern'

export interface PageModalProps {
  modal: ReturnType<typeof mapModal>
}

export interface ModalReferenceProps {
  reference: ReturnType<typeof mapModal>['reference']
}

const ModalReference = ({ reference }: ModalReferenceProps) => {
  return match(reference)
    .with({ __dataType: 'form' }, (form) => <Form {...form} />)
    .otherwise(() => null)
}

export const PageModal: FC<PageModalProps> = ({ modal }) => {
  const [paramModalId, setParamModalId] = useState<string | null>(null)
  const { modalId, reference, trackingId } = modal
  const { matomoPageTemplate } = useContext(AppProviderContext)
  const handleDismissModal = useCallback(() => {
    setParamModalId(null)
  }, [])

  useLayoutEffect(() => {
    document.addEventListener('click', (event) => {
      const target = event.target as HTMLElement
      const dataModalId = target.getAttribute('data-modal-id')

      if (dataModalId) {
        event.preventDefault()
        event.stopPropagation()
        setParamModalId(dataModalId)

        const trackingId = target.getAttribute('data-t-id')

        if (modalId === dataModalId) {
          matomo.trackCoralEvent({
            eventAction: 'open-modal',
            eventCategory: 'sign-up',
            eventName: `trackingId: ${trackingId} > modalId: ${dataModalId} > ${
              target.innerText || target.textContent
            }`,
          })
        }
      }
    })

    //cleanup
    return () => {
      document.removeEventListener('click', () => {})
      setParamModalId(null)
    }
  }, [matomoPageTemplate, modalId, reference?.headline])

  return (
    <>
      {modalId === paramModalId && (
        <Modal
          className={'page-modal'}
          closeCallback={() => handleDismissModal()}
          closeTrackingCallback={(type) => {
            matomo.trackCoralEvent({
              eventAction: 'close-modal',
              eventCategory: 'sign-up',
              eventName: `trackingId: ${trackingId} > closeType: ${type}`,
            })
          }}
          overlayBackgroundColor={'dark'}
          overlayScroll={true}
          position={'center'}
          style={{ padding: '0px', margin: '0px' }}
          trackingId={trackingId}
        >
          <ModalReference reference={reference} />
        </Modal>
      )}
    </>
  )
}
